import type { TranslationDraft } from "@/api/types";

/** Человекочитаемое название черновика: явный metadata.title, иначе
 *  сниппет исходника, иначе «Без названия». Названия хранятся в metadata
 *  (jsonb) — без миграции схемы. */
export function draftTitle(
  d: Pick<TranslationDraft, "metadata" | "source_text">,
  maxLen = 60,
): string {
  const meta = (d.metadata ?? {}) as Record<string, unknown>;
  const explicit = typeof meta.title === "string" ? meta.title.trim() : "";
  if (explicit) {
    return explicit.length > maxLen
      ? `${explicit.slice(0, maxLen)}…`
      : explicit;
  }
  const src = (d.source_text ?? "").trim();
  if (src) return src.length > maxLen ? `${src.slice(0, maxLen)}…` : src;
  return "Без названия";
}

/** Текущее явное название (для префилла prompt'а при переименовании). */
export function currentDraftTitle(
  d: Pick<TranslationDraft, "metadata">,
): string {
  const meta = (d.metadata ?? {}) as Record<string, unknown>;
  return typeof meta.title === "string" ? meta.title : "";
}
